import React from "react";
import { Routes, Route, Link, BrowserRouter } from "react-router-dom";
import { LoginScreen } from "../auth/LoginScreen";
import { DashboardRouter } from "./DashboardRouter";
import { PrivateRoute } from "./PrivateRoutes";
import { SuccessCuLogin } from "../pages/Otro/SuccessCuLogin";

export const AppRouter = ({ usuario }) => {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />}></Route>
      <Route path="/successCuLogin" element={<SuccessCuLogin />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DashboardRouter />
          </PrivateRoute>
        }
      ></Route>
    </Routes>
  );
};
